module.exports = __webpack_public_path__ + "static/media/young-final.cc4272b0.svg";